//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: [
    'cursos',
    'curso',
    'check-class',
    'isup',
    'onFooter',
    'tipo',
    'curriculoTitle',
  ],
  data() {
    return {
      banner: {},
    }
  },
  computed: {
    setInicio() {
      let inicio

      if (this.curso.turmas && this.curso.turmas.length) {
        let txt = (t, i) => {
          let turma =
            this.curso.turmas.length > 1
              ? `<span class="font-600">Turma 0${i + 1}</span>:<br> `
              : ''

          return (
            turma +
            t.inicio +
            (t.horario ? ' <br> ' + t.horario : '') +
            '<br>' +
            '<br>'
          )
        }
        this.curso.turmas.forEach((t, i) => {
          inicio = inicio ? inicio + txt(t, i) : txt(t, i)
        })
      } else {
        if (
          this.curso.data_inicio === '' &&
          this.curso.mes_inicio === '' &&
          this.curso.ano_inicio === ''
        ) {
          inicio = 'a definir'
        } else {
          inicio = this.curso.data_inicio
            ? this.curso.data_inicio +
              ' de ' +
              this.curso.mes_inicio +
              ' de ' +
              this.curso.ano_inicio
            : '' + this.curso.mes_inicio + ' de ' + this.curso.ano_inicio
        }
      }
      return inicio
    },

    decodedPrecos() {
      if (this.curso.investimento) {
        if (typeof this.curso.investimento === 'string') {
          return JSON.parse(this.curso.investimento)
        } else {
          return this.curso.investimento
        }
      } else {
        return []
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.banner = this.$refs.banner
    }, 500)
    setTimeout(() => {
      if (location.hash) {
        let element = document.querySelector(location.hash)
        let banner = document.querySelector(
          '.banner-portal-turismo-show'
        ).offsetHeight
        let elTop = element.offsetTop + banner - 90
        scrollTo({ top: elTop, behavior: 'smooth' })
      }
    }, 1300)
  },
}
